module.exports = __webpack_public_path__ + "img/nudelsalat.6da07e06.jpg";